export default __webpack_public_path__ + "static/media/normal.85d4fca4.cur";